module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ag-table', {
    staticClass: "conseillers-table",
    attrs: {
      "columns": _vm.columnDefs,
      "rows": _vm.rowDataFiltered,
      "customOptions": _vm.tableOptions
    },
    on: {
      "cellclick": _vm.handleCellClick
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cb328b3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Conseillers/ConseillersTable.vue
// module id = 633
// module chunks = 1